module.exports = __webpack_public_path__ + "static/media/042-spoon and fork.fbaea547.svg";